import $ from 'jquery';

const $projectEl = $('.project');
let isShown = false;

if ($projectEl.length > 0) {
    $projectEl.each(function () {
        bindButton($(this));
    });
}

function bindButton(element) {
    element.on('click', '#show-images', function () {
        if (!isShown) {
            element.find('.project__image--hidden').removeClass('project__image--hidden');
            $(this).html('Sbalit galerii');
            isShown = true;
        } else {
            element.find('.to-hide').addClass('project__image--hidden');
            $(this).html('Zobrazit celou galerii');
            isShown = false;
        }
    });
}
